import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

// Import types
import { PacketSubtype } from 'types/api/products/product';
import type { PacketWithPriceAndChannels } from 'types/views/configurator';

// Import helpers
import { fetchPacketsBySubtype } from 'helpers/api/packets';

export const fetchConfiguratorPackets = createAsyncThunk('configurator/fetchConfiguratorPackets', fetchPacketsBySubtype);

type State = {
	isLoading: boolean;
	isError: boolean;
	main: PacketWithPriceAndChannels[];
	premium: PacketWithPriceAndChannels[];
};

const initialState: State = {
	isLoading: true,
	isError: false,
	main: [],
	premium: []
};

const packetsSlice = createSlice({
	name: 'configurator_packets',
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder.addCase(fetchConfiguratorPackets.pending, (state) => {
			state.isLoading = true;
			state.isError = false;
		});
		builder.addCase(fetchConfiguratorPackets.fulfilled, (state, action) => {
			state.main = action.payload.filter((packet) => packet.subtype === PacketSubtype.Main);
			state.premium = action.payload.filter((packet) => packet.subtype === PacketSubtype.Premium);
			state.isLoading = false;
			state.isError = false;
		});
		builder.addCase(fetchConfiguratorPackets.rejected, (state) => {
			state.main = [];
			state.premium = [];
			state.isLoading = false;
			state.isError = true;
		});
	}
});

export default packetsSlice.reducer;
